import React from 'react';

export default function CalenderIcon() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4739 2.17779H14.1056V1.24388C14.1056 0.556912 13.5487 0 12.8618 0H12.812C12.125 0 11.5681 0.556912 11.5681 1.24388V2.17779H5.14968V1.24388C5.14968 0.556912 4.59277 0 3.9058 0H3.85604C3.16907 0 2.61216 0.556912 2.61216 1.24388V2.17779H1.24388C0.556912 2.17779 0 2.7347 0 3.42168V16.7561C0 17.4432 0.556912 18 1.24388 18H15.4739C16.1609 18 16.7178 17.4432 16.7178 16.7561V3.42168C16.7178 2.7347 16.1608 2.17779 15.4739 2.17779ZM14.6281 16.0347H2.08973V5.93432H14.6281V16.0347Z"
        fill="#525B65"
      />
      <path
        d="M3.79393 10.5051H5.95819C6.0681 10.5051 6.15721 10.4159 6.15721 10.306V8.14177C6.15721 8.03186 6.0681 7.94275 5.95819 7.94275H3.79393C3.68402 7.94275 3.59491 8.03186 3.59491 8.14177V10.306C3.59491 10.4159 3.68402 10.5051 3.79393 10.5051Z"
        fill="#525B65"
      />
      <path
        d="M7.27678 10.5051H9.44104C9.55095 10.5051 9.64006 10.4159 9.64006 10.306V8.14177C9.64006 8.03186 9.55095 7.94275 9.44104 7.94275H7.27678C7.16687 7.94275 7.07776 8.03186 7.07776 8.14177V10.306C7.07776 10.4159 7.16687 10.5051 7.27678 10.5051Z"
        fill="#525B65"
      />
      <path
        d="M10.7596 10.5051H12.9239C13.0338 10.5051 13.1229 10.4159 13.1229 10.306V8.14177C13.1229 8.03186 13.0338 7.94275 12.9239 7.94275H10.7596C10.6497 7.94275 10.5606 8.03186 10.5606 8.14177V10.306C10.5606 10.4159 10.6497 10.5051 10.7596 10.5051Z"
        fill="#525B65"
      />
      <path
        d="M3.79393 13.9879H5.95819C6.0681 13.9879 6.15721 13.8988 6.15721 13.7889V11.6247C6.15721 11.5148 6.0681 11.4256 5.95819 11.4256H3.79393C3.68402 11.4256 3.59491 11.5148 3.59491 11.6247V13.7889C3.59491 13.8988 3.68402 13.9879 3.79393 13.9879Z"
        fill="#525B65"
      />
      <path
        d="M7.27678 13.9879H9.44104C9.55095 13.9879 9.64006 13.8988 9.64006 13.7889V11.6247C9.64006 11.5148 9.55095 11.4256 9.44104 11.4256H7.27678C7.16687 11.4256 7.07776 11.5148 7.07776 11.6247V13.7889C7.07776 13.8988 7.16687 13.9879 7.27678 13.9879Z"
        fill="#525B65"
      />
      <path
        d="M10.7596 13.9879H12.9239C13.0338 13.9879 13.1229 13.8988 13.1229 13.7889V11.6247C13.1229 11.5148 13.0338 11.4256 12.9239 11.4256H10.7596C10.6497 11.4256 10.5606 11.5148 10.5606 11.6247V13.7889C10.5606 13.8988 10.6497 13.9879 10.7596 13.9879Z"
        fill="#525B65"
      />
    </svg>
  );
}
